import ELF from '@hb/elf';
import appConst, { setConst } from '@/const/app.const';

const initELF = async () => {
  if (appConst.env === 'pro' || !ELF) {
    return Promise.resolve();
  }
  return new Promise((resolve) => {
    const elf = new ELF({
      envConfig: ['fat', 'uat', 'pro'],
      // tianQiUbtInstance: window.TianQi.UBT,
      // 非必需，若为空则默认从localStorage中获取上一次选择的环境
      // currentEnv: process.env.REACT_APP_ENV,
    });

    elf
      .on('envChanged', (event: any) => {
        setConst(event.data);
      })
      .on('load', () => {
        // load事件在envChanged之后触发
        // 可以用于项目实例的初始化，避免请求先于envChanged事件发出的问题
        // new Vue({ el: '#app' });
        resolve();
      });
  });
};

export default initELF;
